var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", width: "12", height: "14", viewBox: "0 0 12 14" }, props),
    React.createElement(
      "g",
      { transform: "translate(-593 -81)", fill: "#346576" },
      React.createElement("path", { id: "a", d: "M598.325 91.444c-2.1 0-3.825-1.781-3.825-4.048 0-2.267 1.725-4.13 3.825-4.13s3.825 1.863 3.825 4.13-1.725 4.048-3.825 4.048zm4.2-.647a5.84 5.84 0 0 0 1.05-3.401c0-3.158-2.325-5.749-5.25-5.749S593 84.238 593 87.396c0 3.158 2.4 5.749 5.325 5.749 1.2 0 2.325-.405 3.15-1.134l2.25 2.43c.15.161.375.242.525.242.15 0 .375-.08.525-.243.3-.324.3-.81 0-1.133z" }),
      React.createElement("use", { xlinkHref: "#a" })
    )
  );
});